import { Field } from 'formik';
import DatePicker from "react-datepicker";
import { useState } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import { calculateAge } from './common';


const GenderDOBComponent = ({ errors, values, setFieldValue, touched, prefix, handleBlur, handleReset }) => {

    const [startDate, setStartDate] = useState(() => {
        if (values.dateOfBirth) {
            return Date.parse((values.dateOfBirth));
        } else {
            return null;
        }
    });

    const handleGenderChange = (genderStr, setFieldValue) => {
        setFieldValue("gender", genderStr)
    }

    const handleDOBChange = (selectedDate, setFieldValue) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        
        if (!selectedDate) {
            setFieldValue('dateOfBirth', null);
            setStartDate(null);
            setFieldValue('age', '');
            return;
        }

        const selectedDateMidnight = new Date(selectedDate);
        selectedDateMidnight.setHours(0, 0, 0, 0);

        if (selectedDateMidnight.getTime() === today.getTime()) {
            setFieldValue('dateOfBirth', null);
            setStartDate(null);
            setFieldValue('age', '');
            return;
        }

        setFieldValue('dateOfBirth', selectedDate);
        setStartDate(selectedDate);
        var patientAge = calculateAge(selectedDate);
        setFieldValue('age', patientAge);
    }

    return (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
                <label htmlFor="gender" className="block text-sm font-medium text-gray-700 mb-1">
                    Gender <span className="text-red-500">*</span>
                </label>
                <select
                    name="gender"
                    aria-label="Gender"
                    id="gender-select"
                    defaultValue={values.gender}
                    onBlur={handleBlur}
                    onChange={(e) => handleGenderChange(e.target.value, setFieldValue)}
                    className={`block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-teal-500 focus:border-teal-500 ${
                        errors.gender && touched.gender ? 'border-red-500 bg-red-50' : 'border-gray-300'
                    }`}
                >
                    <option value="">Select</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Prefer not to disclose">Prefer not to disclose</option>
                </select>
                {errors.gender && touched.gender ? (
                    <div className="mt-1 text-sm text-red-600">{errors.gender}</div>
                ) : null}
            </div>

            <div>
                <label htmlFor="dateOfBirth" className="block text-sm font-medium text-gray-700 mb-1">
                    Date of Birth 
                </label>
                <DatePicker 
                    selected={startDate} 
                    onChange={(date) => handleDOBChange(date, setFieldValue)}
                    className={`block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-teal-500 focus:border-teal-500 ${
                        errors.age && touched.dateOfBirth ? 'border-red-500 bg-red-50' : 'border-gray-300'
                    }`}
                    onBlur={handleBlur} 
                    id="date-picker" 
                    showYearDropdown
                    showMonthDropdown
                    scrollableYearDropdown
                    dropdownMode="select"
                    yearDropdownItemNumber={100}
                    maxDate={new Date()}
                />
                {errors.age && touched.dateOfBirth ? (
                    <div className="mt-1 text-sm text-red-600">{errors.age}</div>
                ) : null}
            </div>

            <div>
                <label htmlFor="age" className="block text-sm font-medium text-gray-700 mb-1">
                    Age
                </label>
                <Field 
                    type="text" 
                    id={`${prefix}-input_age`} 
                    name="age" 
                    disabled
                    onBlur={handleBlur}
                    className="block w-full px-3 py-2 border rounded-md shadow-sm bg-gray-100 text-gray-500 border-gray-300 cursor-not-allowed"
                />
            </div>
        </div>
    );
}

export default GenderDOBComponent;